import styles from 'common/ActivityChip/styles.module.css';

const ShiftTailLayout = () => {
	return <div className={styles.shiftTail} />;
};

export default ShiftTailLayout;
